import type { ReactNode } from 'react'
import { useSession } from '../api/hooks.js'
import { Login } from './Login.js'

export function AuthGate({ children }: { children: ReactNode }) {
  const session = useSession()

  if (session.isLoading) {
    return (
      <div className="flex min-h-dvh items-center justify-center bg-[var(--bg)]">
        <span className="tabular text-[11px] uppercase tracking-[0.14em] text-[var(--text-subtle)]">Loading…</span>
      </div>
    )
  }

  // A failed session check offline should not throw me out — but with no cached
  // answer at all there is nothing to show but the login.
  if (!session.data?.authenticated) return <Login />

  return <>{children}</>
}
